import type { ButtonProps } from '@polyai/ui/components/atoms/Button';
import Text from '@polyai/ui/components/atoms/Text';
import { Modal } from '@polyai/ui/components/molecules/Modal';

import type { UnsavedChangesModalUICopy } from './types';
import { UNSAVED_CHANGES_MODAL } from './UnsavedChangesModal.uiCopy';

interface UnsavedChangesModalType extends Modal.RootProps {
  uiCopy?: UnsavedChangesModalUICopy;
  confirm?: Omit<ButtonProps, 'label'> & { label?: string };
  cancel?: Omit<ButtonProps, 'label'> & { label?: string };
}

const UnsavedChangesModal: React.FC<UnsavedChangesModalType> = ({
  uiCopy = UNSAVED_CHANGES_MODAL,
  confirm,
  cancel,
  ...props
}) => {
  return (
    <Modal.Root {...props}>
      <Modal.Content size="sm">
        <Modal.Title>{uiCopy.title}</Modal.Title>
        <Text color="textSecondary">{uiCopy.description}</Text>
        <Modal.Footer
          className="mt-sm4"
          primary={{
            label: uiCopy.button.confirm,
            variant: 'DANGER',
            ...confirm,
          }}
          secondary={{
            label: uiCopy.button.cancel,
            ...cancel,
          }}
        />
      </Modal.Content>
    </Modal.Root>
  );
};

export default UnsavedChangesModal;
